// 工具类

// import { reject } from 'core-js/fn/promise'
import gv from '@/api/global_variable'
import dayjs from 'dayjs'
// 格式化数据，将数字num变成length位
export function formatNum(num, length) {
  return ('' + num).length < length
    ? (new Array(length + 1).join('0') + num).slice(-length)
    : '' + num
}
// 生成编号，格式gym+8位日期+4位职工号+5位订单编号
export function generateOrderId(userName, orderId) {
  return dayjs().format('YYYYMMDD') + userName + formatNum(orderId, 6)
}
// file对象 => img对象
export function readImg(file) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const reader = new FileReader()
    reader.onload = function (e) {
      img.src = e.target.result
    }
    reader.onerror = function (e) {
      reject(e)
    }
    reader.readAsDataURL(file)
    img.onload = function () {
      resolve(img)
    }
    img.onerror = function (e) {
      reject(e)
    }
  })
}
// 动态获取缩略图
export function getThumb(list) {
  const fieldList = gv.fieldList
  for (const item of list) {
    for (const field of fieldList) {
      if (item.venueName && item.venueName.indexOf(field.keyword) > -1) {
        item.thumb = field.thumb
        // 跳出里层循环
        break
      } else if (
        item.gymVenue &&
        item.gymVenue.venueName.indexOf(field.keyword) > -1
      ) {
        // 将场地缩略图写入remark属性中
        item.thumb = field.thumb
        // 跳出里层循环
        break
      }
    }
  }
  return list
}

export function dateFormat(fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(),        // 年
    "m+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "M+": date.getMinutes().toString(),         // 分
    "S+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    };
  };
  return fmt;
}
